const {ConstructorPageType} = require('@yandex-data-ui/cloud-schemas/build/models/ui-api');
const {HOME_CONSTRUCTOR_NAME} = require('./constants');

const indexRegex = /^\/$/;
const docRegex = /^\/docs(\/.*)$/;
const mktProductRegex = /^\/marketplace\/products\/([^/]+(\/?[^/]+)?)$/;
const mktDashboardRegex = /^\/marketplace$/;
const blogPostRegex = /^\/blog\/posts\/((\d{4})\/(\d{2})\/([\w-]+))/;
const blogRegex = /^\/blog$/;
const searchRegex = /^\/search$/;
const communityRegex = /^\/community$/;
const eventsRegex = /^\/events$/;
const eventRegex = /^\/events\/([\d]+)$/;
const featuresRegex = /^\/features$/;
const featureRegex = /^\/features\/(\d+)$/;
const casesRegex = /^\/cases$/;
const caseRegex = /^\/cases\/([\d\w_-]+)$/;
const imageGeneratorRegex = /^\/image-generator\/(.*)$/;
const solutionsRegex = /^\/solutions$/;
const scaleRegex = /^\/scale-(\d{4})$/;
const scalePagesRegex = /^\/scale-(\d{4})/;
const partnersCatalogueRegex = /^\/partners\/catalogue$/;
const partnerDetailRegex = /^\/partners\/catalogue\/([^/]+)$/;
const partnerProductDetailRegex = /^\/partners\/catalogue\/product\/([^/]+)$/;

function matchPage(regex, page) {
    return page.match(regex);
}

function matchConstructablePage(pagesList, pageName, versionId, pageType) {
    const page = pagesList.find(
        ({type, name, published}) =>
            pageName === `/${name}` && (versionId || published) && (!pageType || type === pageType),
    );

    return page && page.name;
}

const getConstructableMatch = ({route, constructablePages, query}, type) =>
    matchConstructablePage(constructablePages, route, query && query.versionId, type);

const getConstructablePageParams = (ctx, type) => {
    const page = getConstructableMatch(ctx, type);

    return page && {page, params: ctx.query};
};

const routes = [
    {
        name: 'index',
        pageId: '/_constructor',
        regex: indexRegex,
        hasParams: true,
        getParams: (ctx) => ({page: HOME_CONSTRUCTOR_NAME, params: ctx.query}),
    },
    {
        name: 'constructor',
        pageId: '/_constructor',
        hasParams: true,
        hasMatch: (ctx) => Boolean(getConstructableMatch(ctx, ConstructorPageType.Default)),
        getParams: (ctx) => getConstructablePageParams(ctx, ConstructorPageType.Default),
    },
    {
        name: 'docs',
        pageId: '/_doc',
        regex: docRegex,
        hasParams: true,
    },
    {
        name: 'marketplace',
        regex: mktDashboardRegex,
    },
    {
        name: 'marketplaceProduct',
        pageId: '/_mkt-product',
        regex: mktProductRegex,
        hasParams: true,
    },
    {
        name: 'blog',
        langs: 'ru',
        regex: blogRegex,
    },
    {
        name: 'blogPost',
        langs: 'ru',
        pageId: '/_blog-post',
        regex: blogPostRegex,
        hasParams: true,
    },
    {
        name: 'search',
        regex: searchRegex,
    },
    {
        name: 'community',
        langs: 'ru',
        regex: communityRegex,
    },
    {
        name: 'events',
        langs: 'ru',
        regex: eventsRegex,
    },
    {
        name: 'event',
        langs: 'ru',
        pageId: '/_event',
        regex: eventRegex,
        hasParams: true,
    },
    {
        name: 'features',
        langs: 'ru',
        regex: featuresRegex,
    },
    {
        name: 'feature',
        langs: 'ru',
        pageId: '/_feature',
        regex: featureRegex,
        hasParams: true,
    },
    {
        name: 'cases',
        regex: casesRegex,
    },
    {
        name: 'case',
        pageId: '/_case',
        regex: caseRegex,
        hasParams: true,
    },
    {
        name: 'imageGenerator',
        pageId: '/_image-generator',
        regex: imageGeneratorRegex,
        appData: {clearPage: true},
    },
    {
        name: 'solutions',
        regex: solutionsRegex,
    },
    {
        name: 'scale',
        pageId: '/_scale',
        hasParams: true,
        hasMatch: (ctx) => Boolean(getConstructableMatch(ctx, ConstructorPageType.Scale)),
        getParams: (ctx) => getConstructablePageParams(ctx, ConstructorPageType.Scale),
        appData: {clearPage: true},
    },
    {
        // TODO remove after migration to new configs
        name: 'scale',
        regex: scalePagesRegex,
        hasParams: true,
        appData: {clearPage: true},
    },
    {
        name: 'partners',
        pageId: '/partners/catalogue',
        regex: partnersCatalogueRegex,
        langs: 'ru',
    },
    {
        name: 'partner',
        pageId: '/_partner-details',
        regex: partnerDetailRegex,
        hasParams: true,
        langs: 'ru',
    },
    {
        name: 'partnerProduct',
        pageId: '/_partner-product-details',
        regex: partnerProductDetailRegex,
        hasParams: true,
        langs: 'ru',
    },
];

module.exports = {
    routes,
    matchPage,
    matchConstructablePage,
    indexRegex,
    docRegex,
    mktProductRegex,
    mktDashboardRegex,
    blogPostRegex,
    blogRegex,
    searchRegex,
    communityRegex,
    eventsRegex,
    eventRegex,
    featuresRegex,
    featureRegex,
    casesRegex,
    caseRegex,
    imageGeneratorRegex,
    solutionsRegex,
    scaleRegex,
    scalePagesRegex,
    partnersCatalogueRegex,
    partnerDetailRegex,
    partnerProductDetailRegex,
};
